import React from "react";
import Moment from "react-moment";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useUpdContentActiveStatusMutation } from "../../../../../store/admin/adminContentsApiSlice";
export interface Props {data:any, getList:Function}
export const ListContents:React.FC<Props> = ({data, getList}) => {
    const {contentsType} = useParams()
    const [updContentAcitveStatusApi] = useUpdContentActiveStatusMutation()
    const location = useLocation()
    const navigate = useNavigate()
    const handleChangeActiveStatus = async(idx: any, status : string) =>{
        const result : any = await updContentAcitveStatusApi({idx: idx, status : status === 'Y' ? 'N' : 'Y'});
        if(result.data.result === true){getList()}
    }
    return(
        <>
        <tbody>
            {data?.map((list:any, index : number) => (
            <tr className="active" key={index}>

                {contentsType === '1' || contentsType === '2' ?
                <td onClick={()=>navigate(`${location.pathname}/${list?.prom_idx}`)}>
                    <img src={list?.prom_thumnail_pdsFile_kr} alt="모델링 썸네일 이미지"/>
                </td> : ''
                }

                {contentsType === '1' || contentsType === '2' ? 
                <td onClick={()=>navigate(`${location.pathname}/${list?.prom_idx}`)}>
                    <span>{list?.prom_tech_type}</span>
                </td> : ''
                }

                <td onClick={()=>navigate(`${location.pathname}/${list?.prom_idx}`)}>
                    <span>{list?.prom_subject_kr}</span>
                </td>

                <td onClick={()=>navigate(`${location.pathname}/${list?.prom_idx}`)}>
                    <Moment format="YYYY.MM.DD">{list?.prom_mdate}</Moment>
                </td>

                <td>
                    <span className="toggleSwitch">
                        <input type="checkbox" id={list?.prom_idx} onChange={()=>handleChangeActiveStatus(list?.prom_idx, list?.prom_active_status)} checked={list?.prom_active_status === 'Y' ? true : false} className="toggleIpt" hidden/>
                        <label htmlFor={list?.prom_idx} className="toggleSwitch">
                            <span className="toggleButton"></span>
                        </label>
                    </span>
                </td>
            </tr>
            ))}
        </tbody>
        </>
    )
}